import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=5ab41c21&scoped=true&"
import script from "./Footer.vue?vue&type=script&setup=true&lang=js&"
export * from "./Footer.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=5ab41c21&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab41c21",
  null
  
)

export default component.exports